import { useEffect, useState } from "react";

export const hostedPageStyle = {
  minHeight: "100vh",
  display: "flex",
  flexDirection: "column",
  background: "#F5F5F5",
  fontFamily: "Rubik, sans-serif",
  color: "#1E2635",
};

const navbarStyle = {
  background: "#FFFFFF",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.02)",
  boxSizing: "border-box",
};

const brandStyle = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  minWidth: 0,
  flex: "1 1 auto",
  overflow: "hidden",
};

const langStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 10,
  height: 34,
  padding: "7px 12px 7px 10px",
  border: "1px solid #DBDBDB",
  borderRadius: 10,
  background: "#FFFFFF",
  color: "#1E2635",
  fontSize: 12,
  fontWeight: 500,
  lineHeight: "18px",
  boxSizing: "border-box",
  flexShrink: 0,
};

const poweredStyle = {
  background: "#FFFFFF",
  border: "1px solid #E1E3E4",
  borderRadius: 12,
  padding: 15,
  display: "inline-flex",
  alignItems: "center",
  gap: 8,
  boxSizing: "border-box",
};

const navCss = `
  .dd-nav {
    position: sticky;
    top: 0;
    z-index: 10;
    flex-shrink: 0;
    width: 100%;
    height: auto;
    padding: 8px 20px;
  }
  .dd-nav-mark {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    background: #FFFFFF;
    box-sizing: border-box;
  }
  .dd-nav-mark.is-empty {
    border: 1px solid #E1E3E4;
  }
  .dd-nav-mark.has-logo {
    width: auto;
    height: 34px;
    border-radius: 0;
    background: transparent;
    overflow: visible;
  }
  .dd-nav-mark.has-logo img {
    display: block;
    width: auto;
    height: 34px;
    object-fit: contain;
  }
  .dd-nav-brand {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #1E2635;
  }
  @media (min-width: 1024px) {
    .dd-nav {
      height: 64px;
      padding: 8px 72px;
    }
    .dd-nav-mark {
      width: 24px;
      height: 24px;
    }
    .dd-nav-mark.has-logo,
    .dd-nav-mark.has-logo img {
      height: 48px;
    }
    .dd-nav-brand {
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
    }
  }
`;

export function DirectDebitNavbar({ brandName, logoUrl }) {
  const [logoFailed, setLogoFailed] = useState(false);
  const showLogo = Boolean(logoUrl) && !logoFailed;

  useEffect(() => {
    setLogoFailed(false);
  }, [logoUrl]);

  return (
    <>
      <style>{navCss}</style>
      <header className="dd-nav" style={navbarStyle}>
        <span style={brandStyle}>
          <span className={showLogo ? "dd-nav-mark has-logo" : "dd-nav-mark is-empty"}>
            {showLogo ? (
              <img
                src={logoUrl}
                alt=""
                onError={() => setLogoFailed(true)}
              />
            ) : null}
          </span>
          {brandName ? (
            <span className="dd-nav-brand" title={brandName}>{brandName}</span>
          ) : null}
        </span>
        <span style={langStyle}>
          English
          <img src="/assets/images/direct-debit/chevron-down.svg" alt="" width={12} height={12} style={{ width: 12, height: 12, display: "block" }} />
        </span>
      </header>
    </>
  );
}

export function PoweredBy() {
  return (
    <div style={poweredStyle}>
      <span style={{ fontSize: 14, fontWeight: 500, lineHeight: "20px", color: "#1E2635" }}>
        Powered by
      </span>
      <img
        src="/assets/images/direct-debit/singapay.png"
        alt="SingaPay"
        width={101}
        height={21}
        style={{ width: 101, height: 21, display: "block", objectFit: "contain" }}
      />
    </div>
  );
}
